module.exports = __webpack_public_path__ + "static/media/wcp_dus_muc_cle.7699b845.png";